var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedbackEmoji4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.9674,
    cy: 37.9869,
    r: 36.5972,
    stroke: "#27ABB3",
    strokeWidth: 2.77953
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5518 43.5459H26.9258C27.6979 47.8697 30.8171 56.5171 38.9704 56.5171C47.1237 56.5171 50.0886 47.8697 50.5518 43.5459Z",
    fill: "#27ABB3",
    stroke: "#27ABB3",
    strokeWidth: 2.77953
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.457 25.3495C45.457 26.3221 45.6003 27.8183 46.8898 29.1649C48.036 30.3619 51.8328 33.0551 51.976 33.2047C52.1193 33.2795 52.2626 33.3543 52.4059 33.3543C52.5491 33.3543 52.6924 33.2795 52.8357 33.2047C52.979 33.0551 56.7757 30.4367 57.9219 29.1649C59.2114 27.8183 59.3547 26.3221 59.3547 25.3495C59.3547 23.1052 57.6354 21.3097 55.4863 21.3097C54.3401 21.3097 53.1939 21.983 52.4775 23.0304C51.7611 21.983 50.6149 21.3097 49.3255 21.3097C47.248 21.3097 45.457 23.1052 45.457 25.3495Z",
    fill: "#27ABB3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 25.3495C18.5859 26.3221 18.7292 27.8183 20.0187 29.1649C21.1649 30.3619 24.9617 33.0551 25.1049 33.2047C25.2482 33.2795 25.3915 33.3543 25.5348 33.3543C25.678 33.3543 25.8213 33.2795 25.9646 33.2047C26.1079 33.0551 29.9047 30.4367 31.0509 29.1649C32.3403 27.8183 32.4836 26.3221 32.4836 25.3495C32.4836 23.1052 30.7643 21.3097 28.6152 21.3097C27.469 21.3097 26.3228 21.983 25.6064 23.0304C24.89 21.983 23.7438 21.3097 22.4544 21.3097C20.3769 21.3097 18.5859 23.1052 18.5859 25.3495Z",
    fill: "#27ABB3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackEmoji4);
export default __webpack_public_path__ + "static/media/Feedback_emoji_4.362776d4b89fd316be81b78fb42df501.svg";
export { ForwardRef as ReactComponent };